import { useUnit } from 'effector-react'
import {
  $loadingMonitoringList,
  $monitoringList,
  $totalCountOfMonitoringList,
} from 'src/pages/billing/paymentTrafficMonitoring/model'

export const useMonitoringList = () => {
  const monitoringList = useUnit($monitoringList)
  const loadingMonitoringList = useUnit($loadingMonitoringList)
  const totalCount = useUnit($totalCountOfMonitoringList)

  return {
    monitoringList,
    loadingMonitoringList,
    totalCount,
  }
}
